module.exports = __webpack_public_path__ + "img/2.6918e717.jpg";